import { render, staticRenderFns } from "./ApproveDialog.vue?vue&type=template&id=bd3a0ec2&scoped=true"
import script from "./ApproveDialog.vue?vue&type=script&lang=js"
export * from "./ApproveDialog.vue?vue&type=script&lang=js"
import style0 from "./ApproveDialog.vue?vue&type=style&index=0&id=bd3a0ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3a0ec2",
  null
  
)

export default component.exports